import React from 'react';

import {
    AdjustmentsIcon,
} from '@heroicons/react/solid';
import { Link } from 'react-router-dom';
import {Button} from 'player-components';

const NoSessionLoaded = ({setlistSessions, setlistEnabled}) => {

    return <div className="flex flex-1 flex-col space-y-3 justify-start px-6 py-5 items-center text-center mt-8 dark:text-secondary-300">
        <AdjustmentsIcon className="w-20 h-20 "/>
        {!setlistEnabled && <>
            <h3 className="mt-2 text-sm font-medium">No session loaded</h3>
            <Link to="/library"><Button>Go to Song library</Button></Link>
        </>}
        {(setlistEnabled && setlistSessions.length === 0) && <>
            <p>Add a song to you setlist before to start a new session.</p>
            <Link to="/library"><Button>Go to Song library</Button></Link>
        </>}
        {(setlistEnabled && setlistSessions.length > 0 )&& <>
            <p>Choose a song from your setlist to start a session</p>
            <Link to="/setlist"><Button>Go to Your setlist</Button></Link>
        </>}
    </div>
}

export default NoSessionLoaded;